"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.developerCopy = exports.accountCopy = void 0;
exports.accountCopy = {
    tab1: 'Overview',
    tab2: 'Billing',
    developerTab: 'Developer',
    title: 'Account',
    usersTab: 'Users',
    fetchError: 'The server could not be reached, please try again later'
};
exports.developerCopy = {
    noApiKeysYet: 'No API keys yet.',
    noApiKeysYetExplainer: 'Once an API Key is generated, you can find it here.'
};
